import React from 'react'
import { Header, Label, Icon, Message, Segment, Divider, Transition } from 'semantic-ui-react'
import ScoreLabel from './ScoreLabel'

const yellow = '#ffe445'

const AnswerCorrectness = ({ quote }) => {
    if (quote == -1)
        return <Label color='red' size='massive'><Icon name='thumbs down outline' /> Sbagliato</Label>
    if (quote == 0)
        return <Label color='black' size='massive'><Icon name='thumbs down outline' /> Black Answer</Label>
    if (quote > 0)    
        return <Label color='green' size='massive'><Icon name='thumbs up outline' /> Giusto</Label>
}

const Gain = ({ gain, quote, bet, pity_bonus }) => {
    if (pity_bonus)
        return <Header>Saresti fuori dal gioco, ma siccome siamo bravi ti regaliamo 1 punto per continuare a giocare.</Header>
    if (!gain)
        return null
    if (gain < 0)
        return <Header>Non solo non hai vinto, hai dimezzato il tuo bottino!</Header>
    return <div>
        <Divider hidden />
        <Header>
        <table style={{ width: '100%' }}>
            <tr>
                <td style={{ textAlign: 'right', width: '50%' }}>Hai scommesso</td>
                <td style={{ textAlign: 'left', width: '50%' }}><ScoreLabel>{bet}</ScoreLabel> punti</td>
            </tr>
            <tr>
                <td style={{ textAlign: 'right' }}>la risposta era a quota</td>
                <td style={{ textAlign: 'left' }}><ScoreLabel>{quote}</ScoreLabel></td>
            </tr>
            <tr>
                <td style={{ textAlign: 'right' }}>quindi hai guadagnato</td>
                <td style={{ textAlign: 'left' }}><Label size='big' color='green'>{gain}</Label> punti</td>
            </tr>
        </table>
        </Header>
    </div>
}

const PlayerQuestionResult = ({ question,  user_answer, isCompleted }) => {
    const { text, topic} = question
    const {answer, bet, gain, new_balance, quote, pity_bonus } = user_answer
    return (
        <Transition.Group animation='fade up'>
            <Segment style={{ textAlign: 'left', maxWidth: '800px', marginLeft: 'auto', marginRight: 'auto' }}>
                <Label color='purple' ribbon>{topic}</Label>
                <div style={{ textAlign: 'center' }}>
                    <Header as='h2' style={{ fontWeight: 'normal' }}>{text}</Header>
                    <Message value={answer} fluid size='big' textAlign='center' style={{ color: yellow }} content={answer}></Message>
                </div>
            </Segment>

            {!isCompleted ? null :
                <Segment style={{ textAlign: 'center', maxWidth: '800px', marginLeft: 'auto', marginRight: 'auto' }}>
                    <AnswerCorrectness quote={quote} />
                    <Gain gain={gain} quote={quote} bet={bet} pity_bonus={pity_bonus} />
                    <Header>Ora hai <ScoreLabel>{new_balance}</ScoreLabel> punti</Header>
                </Segment>
            }

            
        </Transition.Group>
    )
}

export default PlayerQuestionResult


// WEBPACK FOOTER //
// ./src/components/PlayerQuestionResult.js